module.exports = __webpack_public_path__ + "img/thumb-up-filled_2.96e73d4d.svg";